const API_ENDPOINT = 'UserEmployeeProfileToDoTaskCategories';

export const API_USER_EMPLOYEE_PROFILE_TODO_TASK_CATEGORIES = {
  API_ENDPOINT,
  GET_ALL_DYNAMIC: `${API_ENDPOINT}/GetAllDynamic`,
  POST: `${API_ENDPOINT}/Create`,
  PATCH: (data: Pick<Components.Schemas.UserEmployeeProfileToDoTaskCategory, 'id'>) =>
    `${API_ENDPOINT}/Patch/${data.id}`,
  DELETE: (data: Pick<Components.Schemas.UserEmployeeProfileToDoTaskCategory, 'id'>) =>
    `${API_ENDPOINT}/Delete/${data.id}`,
  INSERT_BULK: `${API_ENDPOINT}/CreateUserEmployeeProfileToDoTaskCategoryBulk`,
};

export interface UserEmployeeProfileTodoTaskCategoryBulkInput {
  toDoTaskCategoryID: string;
  userEmployeeProfileIDs: string[];
}
